

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/audits';
import AuditsTableItem from './AuditsTableItem';
import '../styles/EventsTable.css';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {getToken} from '../adalConfig';
import TablePaginationActionsWrapped from './TablePaginationActionsWrapped'

import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableFooter,
  TablePagination
} from "@material-ui/core";

class AuditsTableComponent extends Component {

  constructor(props) {
    super(props);
    this.state ={
        open: false,
        auditSelected: undefined,
        page: 0,
        rowsPerPage: 25,
    }
}

fetchUser = () => {
  const headers = { Authorization: `Bearer ${getToken()}` };
  fetch('/api/user/current', { headers })
    .then(response => {
      if (response.ok) {
        
        response.json().then(u => {
          return u;
        });
      
      } else {
        
      }
    });
}

handleChangePage = (event, page) => {
  this.setState({page});
};

handleChangeRowsPerPage = event => {
  this.setState({rowsPerPage: event.target.value});
};

handleClickOpen = (e) => {
this.setState({open: true, auditSelected: e})
};

handleClose = (e) => {
this.setState({open: false, auditSelected: e})
};
  
  componentDidMount() {
    this.props.requestAudits();
  }

  renderAuditsTable = (props) => {
    const {rowsPerPage, page} = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, this.props.audits.length - page * rowsPerPage)
    
    return (
      <div className="EventsTable-Wrapper">
        <Table style={{margin: '0 auto', width: '90%'}} className="mb-0">
          <TableHead>
            <tr
              style= {
                {
                  fontSize: '1.3rem'
                }}
            >
              <th>Created</th>
              <th>Type</th>
              <th>User</th>
              <th>Summary</th>
              <th>Details</th>
            </tr>
          </TableHead>
          <TableBody>
          {props.audits.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(i =>
              <AuditsTableItem key={i.id} audit={i} openDialog={this.handleClickOpen}/>
            )}
          </TableBody>
          <TableFooter>
           
                <TablePagination
                  colSpan={6}
                  count={this.props.audits.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActionsWrapped}
                />
              
            </TableFooter>
        </Table>
      </div>
    );
  };


  render() {
    return (
      <div>
        <h1 className='EventH1'>Audit Log</h1>
       
        <Dialog
               open={this.state.open}
               onClose={this.handleClose}
               aria-labelledby="alert-dialog-title"
               aria-describedby="alert-dialog-description"
             >
  <DialogTitle id="alert-dialog-title">Audit Details</DialogTitle>
               <DialogContent>
                 <DialogContentText id="alert-dialog-description">
                 <h3>Summary:</h3>
                 <Typography variant="body1" color="textSecondary" component="p">
                     {this.state.auditSelected !== undefined ? this.state.auditSelected.summary : ''}
                  </Typography>
                  <h3>Type:</h3>
                 <Typography variant="body1" color="textSecondary" component="p">
                     {this.state.auditSelected !== undefined ? this.state.auditSelected.type : ''}
                  </Typography>
                  <h3>User:</h3>
                 <Typography variant="body1" color="textSecondary" component="p">
                     {this.state.auditSelected !== undefined ? this.state.auditSelected.user : ''}
                  </Typography>
                  <h3>Created:</h3>
                 <Typography variant="body1" color="textSecondary" component="p">
                     {this.state.auditSelected !== undefined ? new Date(this.state.auditSelected.created).toLocaleString('en-GB', { timeZone: 'UTC' }) : ''}
                  </Typography>
                  <h3>Details:</h3>
                 <Typography variant="body4" color="textSecondary" component="p">
                      {this.state.auditSelected !== undefined ? this.state.auditSelected.description : ''}
                  </Typography>
                 </DialogContentText>
               </DialogContent>
             </Dialog>
        {this.renderAuditsTable(this.props)}
      </div>
    );
  };
}

const mapDispatchToProps = (dispatch, props) => ({
  requestAudits: (id) => dispatch(actionCreators.requestAudits())
});

const mapStateToProps = (state, props) => {
  return {
    audits: state.audits.audits
  };
}

const AuditsTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuditsTableComponent);

export default AuditsTable;


// WEBPACK FOOTER //
// ./src/components/AuditsTable.js